export const MFRR_CM_BIDS_QUERY_KEY = 'mfrr_cm_bids'
export const MFRR_PUBLISHED_BIDS_QUERY_KEY = 'mfrr_published_bids'
export const MFRR_DELIVERED_BIDS_QUERY_KEY = 'mfrr_delivered_bids'
export const MFRR_CONFIG_QUERY_KEY = 'mfrr_config'
export const MFRR_ENABLED_PRODUCTION_UNITS_QUERY_KEY = 'mfrr_enabled_production_units'
export const MFRR_MARKET_RESULTS_QUERY_KEY = 'mfrr_market_results'
export const MFRR_CREATE_BIDS_ENDPOINT = 'elplan/mfrr/create_mfrr_bids'
export const MFRR_UPDATE_BIDS_ENDPOINT = 'elplan/mfrr/update_mfrr_bids'
export const MFRR_ENABLED_PRODUCTION_UNITS_ENDPOINT = 'elplan/mfrr/enabled_production_units'
export const MFRR_GET_BIDS_ENDPOINT = 'elplan/mfrr/bids'
export const MFRR_PUBLISHED_BIDS_ENDPOINT = 'elplan/mfrr/published_bids'
export const MFRR_DELIVERED_BIDS_ENDPOINT = 'elplan/mfrr/delivered_bids'
export const MFRR_MARKET_RESULTS_ENDPOINT = 'elplan/mfrr/market_results'
export const MFRR_PUBLISH_BIDS_FOR_DATE_ENDPOINT = 'elplan/mfrr/publish_bids_for_date'
export const MFRR_UNPUBLISH_BIDS_ENDPOINT = 'elplan/mfrr/unpublish_bids'
export const MFRR_CONFIG_ENDPOINT = 'elplan/mfrr/config'
